import {
    SCHUKO,
    MENNEKES,
    CHADEMO,
    CCS_COMBO,
    SAE_J1772,
    CEE_2P_E,
    CEE_3P_E,
    CEE_3P_N_E,
    SPEED_CHARGING_FAST,
    SPEED_CHARGING_SEMIFAST,
    SPEED_CHARGING_SLOW,
    SPEED_CHARGING_SLOW_DESCRIPTION,
    SPEED_CHARGING_SEMIFAST_DESCRIPTION,
    SPEED_CHARGING_FAST_DESCRIPTION,
} from 'commons/js/constants'
import { chargingPointSpeedTypes } from '../components/ChargingPointSpeedFilters/ChargingPointSpeedFilters'

export const getActiveFilters = (filters = {}) => {
    return Object.keys(filters).reduce((result, filterName) =>
            filters[filterName]
                ? result + 1
                : result
        , 0)
}

export const getDefaultFilters = () => ({
    chargingPointSpeed: {
        slow: false,
        semifast: false,
        fast: false,
     },
     chargingPointPlugType: {
         schuko: false,
         mennekes: false,
         chademo: false,
         ccscombo: false,
         saej1772: false,
         cee2pe: false,
         cee3pe: false,
         cee3pne: false,
     },
})

const makeIsSpeedTypeFilterEnabled = (speedType) => (filters) => filters && filters.chargingPointSpeed && filters.chargingPointSpeed[speedType]
const makeIsPlugTypeFilterEnabled = (plugType) => (filters) => filters && filters.chargingPointPlugType && filters.chargingPointPlugType[plugType]

const hasPlugChargingSpeed = (chargingSpeed) => (row) => row.plugs.some((plug) => plug.speedChargingType === chargingSpeed)
const hasPlugSlug = (slug) => (row) => row.plugs.some((plug) => plug.slug === slug)

const availableChargingPointSpeedTypeFilters = [
    {
        condition: makeIsSpeedTypeFilterEnabled(SPEED_CHARGING_SLOW_DESCRIPTION),
        filter: hasPlugChargingSpeed(SPEED_CHARGING_SLOW),
    },
    {
        condition: makeIsSpeedTypeFilterEnabled(SPEED_CHARGING_SEMIFAST_DESCRIPTION),
        filter: hasPlugChargingSpeed(SPEED_CHARGING_SEMIFAST),
    },
    {
        condition: makeIsSpeedTypeFilterEnabled(SPEED_CHARGING_FAST_DESCRIPTION),
        filter: hasPlugChargingSpeed(SPEED_CHARGING_FAST),
    },
]

const availableChargingPointPlugTypeFilters = [
    {
        condition: makeIsPlugTypeFilterEnabled('schuko'),
        filter: hasPlugSlug(SCHUKO),
    },
    {
        condition: makeIsPlugTypeFilterEnabled('mennekes'),
        filter: hasPlugSlug(MENNEKES),
    },
    {
        condition: makeIsPlugTypeFilterEnabled('chademo'),
        filter: hasPlugSlug(CHADEMO),
    },
    {
        condition: makeIsPlugTypeFilterEnabled('ccscombo'),
        filter: hasPlugSlug(CCS_COMBO),
    },
    {
        condition: makeIsPlugTypeFilterEnabled('saej1772'),
        filter: hasPlugSlug(SAE_J1772),
    },
    {
        condition: makeIsPlugTypeFilterEnabled('cee2pe'),
        filter: hasPlugSlug(CEE_2P_E),
    },
    {
        condition: makeIsPlugTypeFilterEnabled('cee3pe'),
        filter: hasPlugSlug(CEE_3P_E),
    },
    {
        condition: makeIsPlugTypeFilterEnabled('cee3pne'),
        filter: hasPlugSlug(CEE_3P_N_E),
    },
]

export const makeChargingPointsFilter = (filters) => {
    const speedTypeFilter = getActiveFilters(filters.chargingPointSpeed) > 0
        ? combineFilters(...availableChargingPointSpeedTypeFilters.map(buildFilter(filters)))
        : always(true)
    const plugTypeFilter = getActiveFilters(filters.chargingPointPlugType) > 0
        ? combineFilters(...availableChargingPointPlugTypeFilters.map(buildFilter(filters)))
        : always(true)

    return (arg) => speedTypeFilter(arg) && plugTypeFilter(arg)
}

const combineFilters = (...filters) => (arg) => filters.reduce((result, filter) => result || filter(arg), false)

const always = (val) => () => val

const buildFilter = (filters) => ({ condition, filter }) => condition(filters) ? filter : always(false)

export const getActiveSpeedFilters = (chargingPointSpeed) => {
    const keys = Object.keys(chargingPointSpeed)
    const activeFilters = keys.filter((element) => chargingPointSpeed[element] === true)

    return activeFilters.map((activeFilter) => chargingPointSpeedTypes.find((speedType) => speedType.value === activeFilter))
}

export const getMinimumActiveSpeedFilterText = (activeSpeedFilters) => {
    const speeds = activeSpeedFilters.map((filter) => filter.speedCategory)
    const minSpeed = Math.min(...speeds)
    return activeSpeedFilters.find((filter) => filter.speedCategory === minSpeed).text
}
